module.exports = __webpack_public_path__ + "static/media/twitter.4d402481.svg";